import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

export const sortChangeRequests = (changeRequests: Array<ChangeRequest>) => {
    return changeRequests.sort(
        (a, b) => (b.updateDate ?? '').localeCompare((a.updateDate ?? '')),
    );
};
